/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type PassengerAuthenticationCardStateSubscriptionVariables =
  Types.Exact<{
    fleetVehicle: Types.Scalars['ID']['input']
    tripId: Types.Scalars['ID']['input']
  }>

export type PassengerAuthenticationCardStateSubscription = {
  __typename?: 'Subscription'
  passengerAuthenticationState: {
    __typename?: 'PassengerAuthenticationStateUpdate'
    tripId: string
    state: Types.PassengerAuthenticationState
    plannedNoShowDate: string | null
  }
}

export const PassengerAuthenticationCardStateDocument = gql`
    subscription passengerAuthenticationCardState($fleetVehicle: ID!, $tripId: ID!) {
  passengerAuthenticationState(fleetVehicle: $fleetVehicle, tripId: $tripId) {
    tripId
    state
    plannedNoShowDate
  }
}
    `

/**
 * __usePassengerAuthenticationCardStateSubscription__
 *
 * To run a query within a React component, call `usePassengerAuthenticationCardStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePassengerAuthenticationCardStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerAuthenticationCardStateSubscription({
 *   variables: {
 *      fleetVehicle: // value for 'fleetVehicle'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function usePassengerAuthenticationCardStateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PassengerAuthenticationCardStateSubscription,
    PassengerAuthenticationCardStateSubscriptionVariables
  > &
    (
      | {
          variables: PassengerAuthenticationCardStateSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PassengerAuthenticationCardStateSubscription,
    PassengerAuthenticationCardStateSubscriptionVariables
  >(PassengerAuthenticationCardStateDocument, options)
}
export type PassengerAuthenticationCardStateSubscriptionHookResult = ReturnType<
  typeof usePassengerAuthenticationCardStateSubscription
>
export type PassengerAuthenticationCardStateSubscriptionResult =
  Apollo.SubscriptionResult<PassengerAuthenticationCardStateSubscription>
